export enum UserTypes {
  Tourist = 'tourist',
  Business = 'business',
  Admin = 'admin',
}

export type TUserType = `${UserTypes}`;
